import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withStyles } from '@material-ui/core/styles'
import { clickContactToText, handleMultiChange } from '../../actions/sms'
import Select from 'components/theme/Select'
import { contactsWithPhoneNumbersSelector } from '../../selectors'

const mapStateToProps = (state) => ({
  contactsByID: contactsWithPhoneNumbersSelector(state),
  location: state.router.location,
  sms: state.sms,
})

const mapDispatchToProps = dispatch => bindActionCreators({
  clickContactToText,
  handleMultiChange,
}, dispatch)

const styles = theme => ({
  paper: {
    padding: "10px 25px 10px 10px",
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
  },
})

class TextFields extends Component {
  render() {

    const contactsOptions = Object.keys(this.props.contactsByID).map(id => {
      const contact = this.props.contactsByID[id]
      return {
        contactID: contact.id,
        value: contact.phone,
        label: `${contact.first_name} ${contact.last_name}`
      }
    })

    return (

      <div>
        <Select
          value={this.props.sms.toValue}
          onChange={newValue => this.props.handleMultiChange(newValue)}
          closeMenuOnSelect={false}
          isMulti
          options={contactsOptions}
          placeholder="To: "
        />
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(TextFields))
